import * as apiReducers from './apiReducers';
import * as appReducers from './appReducers';

import { combineReducers } from 'redux';
import http from './httpReducers';
import loading from './loadingReducer';
import teamlocks from './locksReducer';

const reducers = {
  app: combineReducers(appReducers),
  api: combineReducers(apiReducers),
  http,
  loading,
  teamlocks,
};

export default reducers;
